import Stack, {StackProps} from '@mui/material/Stack';
import {styled} from '@mui/material/styles';

export const CStack = styled(Stack)<StackProps>(
  (/* { theme } */) => ({
  }),
);
